import { all, call, fork, put, takeLatest } from "redux-saga/effects"
import { getSearchSuggestionsApi } from "../../services/Api/SearchApi"
import { getErrors, getSuggestionsSuccess } from "../reducers/SearchSuggestReducer"

// Watchers
// takeLatest (not takeEvery) so a stale in-flight request from an earlier
// keystroke can't resolve after a newer one and flash outdated suggestions.
function* searchSuggestSaga() {
	yield takeLatest("search_suggest/getSuggestions", fetchSuggestions)
}

// Sagas
function* fetchSuggestions(action) {
	try {
		const response = yield call(getSearchSuggestionsApi, action.payload)

		if (response.request.status === 200) {
			yield put(getSuggestionsSuccess(response))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(searchSuggestSaga)])
}
